import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type DrawerContent = "default" | "careTeam" | "account";

interface State {
  drawerContent: DrawerContent;
}

const initialState: State = {
  drawerContent: "default",
};

const mobileDrawerContentSlice = createSlice({
  name: "mobileDrawerContent",
  initialState,
  reducers: {
    setMobileDrawerContent(state, action: PayloadAction<DrawerContent>) {
      state.drawerContent = action.payload;
    },
  },
});

export const { setMobileDrawerContent } = mobileDrawerContentSlice.actions;

export const mobileDrawerContentSliceReducer = mobileDrawerContentSlice.reducer;
